import api from '../index';

export type ProposalAnswer = {
  question: string;
  answer: string;
};

type RawAnswer = {
  question?: {body?: string};
  body?: string;
};

const proposalFetchers = {
  answers: async (proposalId: string): Promise<ProposalAnswer[]> => {
    const response = await api.get(`/proposals/${proposalId}`, {
      params: {
        include: 'answers.question',
      },
    });

    const data = (response?.data ?? response) as Record<string, unknown>;
    const answers = (data?.answers ?? []) as RawAnswer[];

    return answers.map((answer) => ({
      question: answer.question?.body ?? '',
      answer: answer.body ?? '',
    }));
  },
};

export default proposalFetchers;
